import React, { Fragment, useEffect, useState } from 'react'
import { CategoryMenu } from './CategoryMenu'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import { OnlyCashStyle as OnlyCash } from './OnlyCash'
import yn from 'yn'

const defaultState = {
  menu: false
}

const MainMenu = ({ categoryMenu, onlyCash, catalogJustCash, profile }) => {
  const [ownState, setOwnState] = useState(defaultState)

  const openTabletMenu = () => {
    setOwnState({
      ...ownState,
      menu: !ownState.menu
    })
  }

  useEffect(() => {
    setTimeout(() => {
      var linkMenu = document.querySelectorAll('button.link-menu')

      Array.from(linkMenu).forEach((link, index) => {
        link.addEventListener('click', function (event) {
          let containClass = link.classList.contains('link-menu-active')
          let allContainers = Array.from(linkMenu)

          allContainers.splice(index, 1)

          allContainers.forEach(container => {
            container.classList.remove('link-menu-active')
            container.setAttribute('aria-expanded', false)
          })

          if (containClass) {
            link.classList.remove('link-menu-active')
            link.setAttribute('aria-expanded', false)
          } else {
            link.classList.add('link-menu-active')
            link.setAttribute('aria-expanded', true)
          }

          event.preventDefault()
        })
      })
    }, 500)
  }, [])

  return (
    <Fragment>
      <nav
        className='container-menu zindex-medium pos-relative bg-brand-4 container-fluid d-none d-sm-block d-print-none'
        aria-label='Menu Principal'
      >
        <div className='container container-with-zoom'>
          <div className='menu menu-without-trade row row-eq-height flex-wrap flex-md-nowrap'>
            <div className='col d-flex align-items-center'>
              <MediaQuery minWidth={421} maxWidth={1024}>
                <a
                  className='pos-absolite h-100 d-flex align-items-center'
                  aria-haspopup='true'
                  aria-expanded={ownState.menu}
                  onClick={openTabletMenu}
                >
                  <i className='icon icon_menu mr-2' aria-hidden='true' />
                  <strong>menu</strong>
                </a>
              </MediaQuery>
              <MediaQuery minWidth={1025}>
                <div className='row'>
                  <CategoryMenu menus={categoryMenu} onlyCash={onlyCash} />
                </div>
              </MediaQuery>
            </div>
            <MediaQuery minWidth={421} maxWidth={1024}>
              <div
                className={`pos-absolute tablet-menu bg-white w-100 l-0 mt-half border-ui-2 ${
                  !yn(ownState.menu) && 'd-none'
                }`}
              >
                <CategoryMenu menus={categoryMenu} onlyCash={onlyCash} openTabletMenu={openTabletMenu} />
              </div>
            </MediaQuery>

            <MediaQuery minWidth={768}>
              <div className='col-auto'>
                <div className='row'>{catalogJustCash ? <OnlyCash profile={profile} /> : ''}</div>
              </div>
            </MediaQuery>
          </div>
        </div>
      </nav>
    </Fragment>
  )
}

MainMenu.propTypes = {
  categoryMenu: PropTypes.object,
  catalogJustCash: PropTypes.bool,
  onlyCash: PropTypes.any,
  profile: PropTypes.object
}

export default MainMenu



// WEBPACK FOOTER //
// ./src/App/MainMenu/MainMenu.js